module.exports = __webpack_public_path__ + "static/regalo-dd82a7276b5517a587e5c4193f8fa612.png";